import React, { useState, useEffect, useContext } from 'react';
import CheckoutForm from '../../components/PaymentForm';
import { useParams, useNavigate } from 'react-router-dom';
import { FirebaseContext } from '../../context/firebase';
import FullScreenLoader from '../../components/loader/FullScreenLoader';
import allIndivialPuppies1 from '../../data/individual-puppy-data/_split_restructured_puppies-data1.json'
// import allIndivialPuppies2 from '../../data/individual-puppy-data/_split_restructured_puppies-data2.json'
// import allIndivialPuppies3 from '../../data/individual-puppy-data/_split_restructured_puppies-data3.json'
// import allIndivialPuppies4 from '../../data/individual-puppy-data/_split_restructured_puppies-data4.json'
// import allIndivialPuppies5 from '../../data/individual-puppy-data/_split_restructured_puppies-data5.json'
// import allIndivialPuppies6 from '../../data/individual-puppy-data/_split_restructured_puppies-data6.json'

const allPuppies: any[][] = [
  allIndivialPuppies1,
  // allIndivialPuppies2,
  // allIndivialPuppies3,
  // allIndivialPuppies4,
  // allIndivialPuppies5,
  // allIndivialPuppies6,
];

function findItemById(arrays, id) {
  for (const array of arrays) {
    const found = array.find(function(item) {
      return item.puppy_id === id;
    });
    if (found) {
      return found;
    }
  }
  return undefined;
}

const CardPaymentPage = () => {
  const { firebase } = useContext(FirebaseContext);
  const navigate = useNavigate();
  const { paymentID } = useParams();

  const [trackingCode, setTrackingCode] = useState(paymentID);
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState(null);
  const [puppyInfo, setPuppyInfo] = useState(null);

  const getUserByPaymentID = async (paymentID) => {
    if (!firebase) return;

    setLoading(true);
    try {
      const querySnapshot = await firebase.firestore()
        .collection('puppy_orders')
        .where('paymentId', '==', paymentID)
        .get();

      if (querySnapshot.empty) {
        navigate('/');
        return;
      }

      const userData = querySnapshot.docs[0].data();

      if (userData.cardPaymentActive) {
        setUserData(userData);

        const puppy = findItemById(allPuppies, userData.puppyId)
        if (puppy){
          setPuppyInfo(puppy)
        }else{
          navigate(`/shop/puppy-tracker/${paymentID}`);
        }

      } else {
        navigate(`/shop/puppy-tracker/${paymentID}`);
      }
    } catch (error) {
      navigate(`/shop/puppy-tracker/${paymentID}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (trackingCode) {
      getUserByPaymentID(trackingCode);
    }
  }, []);

  return (
      <div>
        {loading ? (
          <FullScreenLoader />
        ) : userData && puppyInfo ? (
          <CheckoutForm userData={userData} puppyInfo={puppyInfo} />
        ) : null}
      </div>
  );
};

export default CardPaymentPage;
